import { render, staticRenderFns } from "./Tarifas.vue?vue&type=template&id=1c7b9d62"
import script from "./Tarifas.vue?vue&type=script&lang=js"
export * from "./Tarifas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports